// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__5Mdm7","list":"PatternAutocomplete_list__2ozHg"};